/**
 * Classification paths:
 *  CLIENT/LOAN:
 *  lender                        - list of competitor lenders in country
 *  employment/type               - types of employment: manager, director
 *  employment/industry           - employment industries: IT, banking, law, etc
 *  income/type                   - type of income: employed, unemployed, freelance
 *  document/issuing-authority    - personal document issuers
 *  home-relation                 - client house ownership: owner / rent etc
 *  loan-usage                    - purpose of loan
 *  additional-contact/relation   - relationship with additional contact: wife, friend, father
 *  important-functions           - AML: type of political activity
 *
 *  BANKS:
 *  name                          - list of bank names
 *  bank/city/:name               - list of bank cities by NAME
 *  bank/branch/:city             - list of bank branches by CITY
 *  bank/code/:branch             - code by BRANCH
 *
 *  OFFLINE BRANCHES:
 *  general/city                  - list of cities for offline branches
 *  general/address/:city         - list of addresses for branches by CITY
 */

export class ClassificationController {
  constructor(ctx) {
    this.ctx = ctx;
  }

  /**
   * Get classification from path
   * @param {String} path - classification path used in API call
   * @param {Boolean} transform - flag that indicates if result has to be transformed
   */
  async get(path, transform = true) {
    const { success, data } = await this.ctx.$api.dispatch('classification/get', path, {
      params: { locale: this.ctx.app.$lang.locale },
    });

    if (success && data) {
      return transform ? ClassificationController.transform(data) : data;
    }

    return [];
  }

  /**
   * Transforms response data into select-compatible array of options
   * @param {Object} payload - raw response data
   */
  static transform(payload) {
    return Object.entries(payload).map(([value, label]) => ({
      label,
      value,
    }));
  }
}

export default (ctx, inject) => {
  const classification = new ClassificationController(ctx);
  ctx.$classification = classification;
  inject('classification', classification);
};
